import customStyles from "../../../../assets/styles/customStyles";

const iconStyle = { marginLeft: "10px" };
const customSortIcon = (props) => {
    const classes = customStyles();
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={classes.customSortIcon} style={iconStyle} width="12" height="10" viewBox="0 0 12 10">
            <g dataname="Flow Button">
                <path dataname="Polygon 16" d="m6 0 6 10H0z" transform="rotate(180 6 5)" fill="#d9d9d9" />
            </g>
        </svg>

    )
};

export default customSortIcon;